import { jsx as _jsx } from "react/jsx-runtime";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsCSVExporting from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import lineChartOptions from './lineChartOptions';
var LineChart = function (props) {
    var brandInsights = props.brandInsights, flavorCatInsights = props.flavorCatInsights, selectedMetric = props.selectedMetric;
    var chartOptions = lineChartOptions({ brandInsights: brandInsights, flavorCatInsights: flavorCatInsights, selectedMetric: selectedMetric });
    HighchartsExporting(Highcharts);
    HighchartsCSVExporting(Highcharts);
    Highcharts.setOptions({
        lang: {
            thousandsSep: ','
        }
    });
    return (_jsx(HighchartsReact, { highcharts: Highcharts, options: chartOptions, containerProps: { style: { height: '100%', width: '100%' } } }));
};
export default LineChart;
